import React from 'react';
import { Button, Tooltip } from 'zui/Antd';

const ConditionalTooltipButton = ({
	condition,
	trueTitle,
	falseTitle,
	placement = 'rightBottom',
	disabledCondition,
	onClick,
	buttonText,
	buttonSize = 'medium',
	buttonStyle = { width: '100%', justifyContent: 'start', alignItems: 'center' },
	buttonType = 'default',
	danger,
	icon,
	iconPosition,
	children
}) => {
	return (
		<Tooltip title={condition ? trueTitle : falseTitle} placement={placement}>
			{children ? (
				React.cloneElement(children, { onClick }) // ✅ Ensure children inherit onClick
			) : (
				<Button
					disabled={disabledCondition}
					onClick={onClick}
					size={buttonSize}
					style={buttonStyle}
					type={buttonType}
					danger={danger}
					icon={icon}
					iconPosition={iconPosition}
				>
					{buttonText}
				</Button>
			)}
		</Tooltip>
	);
};

export default ConditionalTooltipButton;
